import addSharedFoldersOperation from 'owa-service/lib/operation/addSharedFoldersOperation';

/**
 * Service to add a shared folder user. Please note that this operation is not aware of account yet,
 * meaning the operation shall be carried for the logged in account. Whenever we want to support this for
 * the connected account we can add the userIdentity context.
 * @param displayName Display name for the shared folder user
 * @param sharedUserMailboxSmtpAddress Smtp address for the shared folder user
 */
export default function addSharedFoldersService(
    displayName: string,
    sharedUserMailboxSmtpAddress: string
): Promise<boolean> {
    return addSharedFoldersOperation({
        displayName: displayName,
        primarySMTPAddress: sharedUserMailboxSmtpAddress,
    });
}
